import PLACEHOLDER_IMG from "@/assets/placeholder.png";
import { IAction, IGameCell, IGameData } from "@/common/interface";
import appProgress from "@/store/common/reducers/appProgress";
import appStatus from "@/store/common/reducers/appStatus";
import { combineReducers } from "redux";
import { SET_GAME_DATA } from "../actionTypes";

const DEFAULT_ITEM: IGameCell = {
  soft_id: 0,
  name: "",
  calendar_title: "",
  pic_href: PLACEHOLDER_IMG,
  icon_pic: PLACEHOLDER_IMG,
  pic_url: PLACEHOLDER_IMG,
  slider_pic_href: PLACEHOLDER_IMG,
  choice_pic_href_max: PLACEHOLDER_IMG,
  single_pic_href: PLACEHOLDER_IMG,
  topright_pic_href: PLACEHOLDER_IMG,
};

const initState: IGameData = {
  banner: [DEFAULT_ITEM],
  top: [DEFAULT_ITEM],
  dataTop: new Array(5).fill(DEFAULT_ITEM),
  network: new Array(8).fill(DEFAULT_ITEM),
  standAlone: new Array(8).fill(DEFAULT_ITEM),
  pageGame: new Array(8).fill(DEFAULT_ITEM),
  hotList: [],
  heatList: [],
  advertising: [],
};

const gameData = (state = initState, action: IAction): IGameData => {
  switch (action.type) {
    case SET_GAME_DATA:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export default combineReducers({
  gameData,
  appStatus,
  appProgress,
});
